import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Check, X, ArrowLeft, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ConfirmSubscription = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [status, setStatus] = useState('loading'); // loading | success | already | error

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/cfq/confirm?token=${encodeURIComponent(token)}`);
        const data = await res.json();
        if (data.success) {
          setStatus(data.message?.includes('Already') ? 'already' : 'success');
        } else {
          setStatus('error');
        }
      } catch {
        setStatus('error');
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#faf9f7] to-white flex items-center justify-center px-6" data-testid="confirm-subscription-page">
      <div className="max-w-md w-full text-center">
        {status === 'loading' && (
          <>
            <Loader2 size={32} className="text-[#C99316] mx-auto mb-4 animate-spin" />
            <h1 className="font-serif text-2xl text-[#071B3A] mb-3">Confirming...</h1>
            <p className="text-slate-500 text-sm">Please wait while we verify your subscription.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-14 h-14 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-5">
              <Check size={28} className="text-emerald-500" />
            </div>
            <h1 className="font-serif text-2xl text-[#071B3A] mb-3">You're confirmed</h1>
            <p className="text-slate-500 text-base leading-relaxed mb-8">
              Welcome to the Cultural Fluency mailing list. You'll receive occasional articles and updates from Dr Promise Monday.
            </p>
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#C99316] hover:underline">
              <ArrowLeft size={14} /> Back to Third Culture Leadership
            </Link>
          </>
        )}

        {status === 'already' && (
          <>
            <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mx-auto mb-5">
              <Check size={28} className="text-blue-500" />
            </div>
            <h1 className="font-serif text-2xl text-[#071B3A] mb-3">Already confirmed</h1>
            <p className="text-slate-500 text-base leading-relaxed mb-8">
              Your subscription is already active. No further action needed.
            </p>
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#C99316] hover:underline">
              <ArrowLeft size={14} /> Back to Third Culture Leadership
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-5">
              <X size={28} className="text-red-500" />
            </div>
            <h1 className="font-serif text-2xl text-[#071B3A] mb-3">Link expired or invalid</h1>
            <p className="text-slate-500 text-base leading-relaxed mb-8">
              This confirmation link may have been used already or is no longer valid. If you'd like to subscribe, try signing up again from the CFQ results page.
            </p>
            <Link to="/cfq-assessment" className="inline-flex items-center gap-2 text-sm text-[#C99316] hover:underline">
              <ArrowLeft size={14} /> Take the CFQ
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmSubscription;
